/**
 * Env resolution:
 * - Local dev: testOpsHub/.env → process.env (Vue CLI)
 * - Deployed: optional window.ENV.VUE_APP_API_URL; Firebase/Google from GET /api/config/web (backend .env)
 */
export function vueEnv(key) {
  if (typeof window !== "undefined" && window.ENV && window.ENV[key] != null) {
    const runtime = String(window.ENV[key]).trim();
    if (runtime) return runtime;
  }
  if (typeof process !== "undefined" && process.env) {
    const v = process.env[key];
    if (v != null && v !== "") return String(v).trim();
  }
  return "";
}
